import { render, staticRenderFns } from "./ModelQuestion.vue?vue&type=template&id=2d1bf1cc&scoped=true"
import script from "./ModelQuestion.vue?vue&type=script&lang=js"
export * from "./ModelQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1bf1cc",
  null
  
)

export default component.exports